import { NotesTrack } from "../notes/NotesTrack";
import { Timeline } from "./Timeline";

export class Arrangement
{
  timeline:Timeline;  
  tracks:NotesTrack[] = [];

}